import React from 'react';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { EMPLOYEE_SHOW } from 'src/constants/EndpointUrls';
import { Hamburger } from 'jbc-front/components/icons';
import { CheckboxFieldWithoutForm } from 'src/components';
import { getList } from 'src/reducers/common/listReducer';
import { takeEmployeesSearchQueries, FORM_NAME_EMPLOYEES_SEARCH } from 'src/reducers/searchForm';
import {
  selectedAllEmployeesCurrentPage,
  getSelectedEmployeeIds,
  getSelectedAllPages,
  selectEmployeeId
} from 'src/reducers/settings/coordinations';
import SortableTh from 'src/components/SortableTh';
import { redirectTo, detailUrlWithQueries, getIdsFromArr } from 'src/utils/Http';
import EmployeeTableRow from './EmployeeTableRow';
import SelectEmployeeMenu from './SelectEmployeeMenu';
import styles from './EmployeeTable.scss';
import { withTranslation } from 'react-i18next';

class EmployeeTable extends React.Component {
  state = { isSelectMenuOpen: false };
  setSelectMenuOpen = isOpen => this.setState({ ...this.state, isSelectMenuOpen: isOpen });

  render() {
    const { employees, queries, dispatch, selectedEmployeeIds, selectedAllPages } = this.props;
    const isSelectedAllEmployeesCurrentPage =
      selectedEmployeeIds && selectedEmployeeIds.length > 0 && selectedEmployeeIds.length === employees.length;

    return (
      <div className="l-overflow-scroll">
        <table className="m-table-list">
          <thead>
            <tr>
              <th width={40}>
                <div className={styles.wrap}>
                  <div
                    role="presentation"
                    onClick={() => {
                      dispatch(selectedAllEmployeesCurrentPage(!isSelectedAllEmployeesCurrentPage));
                    }}
                    className={isSelectedAllEmployeesCurrentPage ? 'theadCheckboxOn' : 'theadCheckboxOff'}
                  >
                    <CheckboxFieldWithoutForm
                      checked={isSelectedAllEmployeesCurrentPage}
                      value={isSelectedAllEmployeesCurrentPage}
                      onChange={() => {
                        dispatch(selectedAllEmployeesCurrentPage(!isSelectedAllEmployeesCurrentPage));
                      }}
                    />
                  </div>
                  <div className={styles.button}>
                    <Hamburger
                      size={12}
                      className={`${styles.menu} ignore-react-onclickoutside`}
                      onClick={() => this.setSelectMenuOpen(!this.state.isSelectMenuOpen)}
                    />
                    {this.state.isSelectMenuOpen && <SelectEmployeeMenu hide={() => this.setSelectMenuOpen(false)} />}
                  </div>
                </div>
              </th>
              <th>{this.props.t('features.EmployeeBonus.components.EmployeeBonusTable.note')}</th>
              <SortableTh
                field="staffCode"
                globalClassName="m-table-list-staffcode"
                formName={FORM_NAME_EMPLOYEES_SEARCH}
              >
                {this.props.t('features.Employees.components.BusinessInfoSection.staff_code')}
              </SortableTh>
              <SortableTh field="name" formName={FORM_NAME_EMPLOYEES_SEARCH}>
                {this.props.t('features.EmployeeBonus.ShowBonusFbDataPage.name')}
              </SortableTh>
              <SortableTh field="employmentTypeId" formName={FORM_NAME_EMPLOYEES_SEARCH}>
                {this.props.t('features.Employees.components.BusinessInfoSection.employment_type')}
              </SortableTh>
              <SortableTh field="groupId" formName={FORM_NAME_EMPLOYEES_SEARCH}>
                {this.props.t('features.Employees.components.BusinessInfoSection.group')}
              </SortableTh>
              <SortableTh field="positionId" formName={FORM_NAME_EMPLOYEES_SEARCH}>
                {this.props.t('features.Employees.components.BusinessInfoSection.position')}
              </SortableTh>
              <SortableTh field="joinedOn" formName={FORM_NAME_EMPLOYEES_SEARCH}>
                {this.props.t('features.Employees.components.BusinessInfoSection.first_day_of_work')}
              </SortableTh>
            </tr>
          </thead>
          <tbody>
            {(!employees || employees.length === 0) && (
              <tr>
                <td colSpan={8}>{this.props.t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
              </tr>
            )}

            {employees.map(employee => {
              const checked = !!selectedAllPages || selectedEmployeeIds.includes(employee.id);

              return (
                <EmployeeTableRow
                  key={employee.id}
                  onClickRow={() =>
                    redirectTo(detailUrlWithQueries(employee.id, queries, EMPLOYEE_SHOW, getIdsFromArr(employees)))
                  }
                  employee={employee}
                  onClickCheckbox={employeeId => dispatch(selectEmployeeId(employeeId))}
                  checked={checked}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  employees: getList(REDUCER_NAME, state),
  queries: takeEmployeesSearchQueries(getFormValues(FORM_NAME_EMPLOYEES_SEARCH)(state)),
  selectedEmployeeIds: getSelectedEmployeeIds(state),
  selectedAllPages: getSelectedAllPages(state)
});

export default withTranslation('translation')(connect(mapStateToProps)(EmployeeTable));
